export default __webpack_public_path__ + "static/media/step3.0fe94cdc.png";